import OrderModel from "@/models/OrderModel";

export default class OrderViewModel extends OrderModel {
	constructor(data?: any) {
		super(data);
		if (data) {
			this.isAsyncOperationPending = data.isItemPriceValid ?? false;
		}
	}

	isAsyncOperationPending = false;
}